import { Profile, ChangePassword, AppointChange, Activity } from "../Components/index.js";

export default [
    {
        path: "/profile/:id",
        component: Profile,
        name: "profile",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/change-password",
        component: ChangePassword,
        name: "change.password",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/user-activity",
        component: Activity,
        name: "user-activity",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/appointment-assign",
        component: AppointChange,
        name: "change.appointment",
        meta: {
            requiresAuth: true,
        },
    },
];
